export const INSERT_CACHE_ITEM = 'INSERT_CACHE_ITEM';
export const DELETE_CACHE_ITEM = 'DELETE_CACHE_ITEM';

export function insertCacheItem(key, item) {
    return {
        type: INSERT_CACHE_ITEM,
        payload: {
            key: key,
            item: item
        }
    };
}

export function deleteCacheItem(key) {
    return {
        type: DELETE_CACHE_ITEM,
        payload: {
            key: key
        }
    };
}
